import { useSelector, shallowEqual } from 'react-redux';
import { matchPath, useLocation } from 'react-router';
import NavigationConfig from 'navigation/config';

export default function useHomePage() {
  const location = useLocation();
  const path = location.pathname;
  const isHomePage = matchPath(path, {
    path: NavigationConfig.homePage().path,
    exact: true,
    strict: false,
  })?.isExact;

  return isHomePage;
}
